import { render, staticRenderFns } from "./Screen2FA.vue?vue&type=template&id=03d2f8f9&scoped=true"
import script from "./Screen2FA.vue?vue&type=script&lang=js"
export * from "./Screen2FA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d2f8f9",
  null
  
)

export default component.exports